import React from "react";
import styled from "styled-components";
import { HorizontalAlignment } from "../types";
import { Device } from "../device";

//Text wrapper: horizontal text alignment.

//Usage:
/*
<Text horizontalAlign="center">
    --Content here--
</Text>
*/

interface TextProps
{
    horizontalAlign?: HorizontalAlignment;
}

const TextWrap = styled.div<TextProps>`
    max-width: 48rem;
    margin: 0 auto 1.5rem auto;
    text-align: ${props =>
        (props.horizontalAlign === "left") ? "left" :
            (props.horizontalAlign === "center") ? "center" :
                (props.horizontalAlign === "right") ? "right" :
                    "inherit"};
    ${Device.tablet} {
        margin-bottom: 0;
    }
    ul {
        list-style-position: inside !important;
        list-style-type: disc !important;
        margin-bottom: 1.5rem;
    }
    > h1, h2{
        &:first-child{
            padding-top: 0.75rem;
        }        
    }
    h3{
        &:first-child{
            padding-top: 0.5rem;
        }
    }
    h4, h5{
        &:first-child{
            padding-top: 0.25rem;
        }
    }
`;

const Text: React.FunctionComponent<TextProps> = (props) => (
    <TextWrap {...props} className="text-wrap">
        {props.children}
    </TextWrap>
);

export default Text;